/** Phaladeepika chapter + topic registry (Mantreshwara · 11 chapters). */

export const PHALADEEPIKA_CHAPTERS = [
  {
    id: 'ch1',
    hi: 'अध्याय 1 · ग्रहस्वरूप',
    en: 'Chapter 1 · Nature of Planets & Signs',
    color: 'from-orange-500/20 via-amber-500/10 to-yellow-500/5',
    ring: { d: 'ring-orange-400/20', l: 'ring-orange-200' },
    badge: { d: 'bg-orange-400/15 text-orange-100', l: 'bg-orange-100 text-orange-900' },
    accent: { d: 'text-orange-200', l: 'text-orange-900' },
    tabs: [
      { id: 'phaladeepika-ch1-s1', hi: '1.1 प्रार्थना', en: 'Prayer' },
      { id: 'phaladeepika-ch1-s2', hi: '1.2 राशिचक्र', en: 'Zodiac' },
      { id: 'phaladeepika-ch1-s3', hi: '1.3 राशि स्वामी', en: 'Sign Lords' },
      { id: 'phaladeepika-ch1-s4', hi: '1.4 उच्च', en: 'Exaltation' },
      { id: 'phaladeepika-ch1-s5', hi: '1.5 नीच', en: 'Debilitation' },
      { id: 'phaladeepika-ch1-s6', hi: '1.6 मूलत्रिकोण', en: 'Mooltrikona' },
      { id: 'phaladeepika-ch1-s7', hi: '1.7 स्वक्षेत्र', en: 'Own Sign' },
      { id: 'phaladeepika-ch1-s8', hi: '1.8 नैसर्गिक मैत्री', en: 'Natural Friends' },
      { id: 'phaladeepika-ch1-s9', hi: '1.9 तात्कालिक मैत्री', en: 'Temp Friends' },
      { id: 'phaladeepika-ch1-s10', hi: '1.10 पंचधा', en: 'Compound' },
      { id: 'phaladeepika-ch1-s11', hi: '1.11 दृष्टि', en: 'Aspects' },
      { id: 'phaladeepika-ch1-s12', hi: '1.12 सूर्य', en: 'Sun' },
      { id: 'phaladeepika-ch1-s13', hi: '1.13 चंद्र', en: 'Moon' },
      { id: 'phaladeepika-ch1-s14', hi: '1.14 मंगल', en: 'Mars' },
      { id: 'phaladeepika-ch1-s15', hi: '1.15 बुध', en: 'Mercury' },
      { id: 'phaladeepika-ch1-s16', hi: '1.16 गुरु', en: 'Jupiter' },
      { id: 'phaladeepika-ch1-s17', hi: '1.17 शुक्र', en: 'Venus' },
      { id: 'phaladeepika-ch1-s18', hi: '1.18 शनि', en: 'Saturn' },
      { id: 'phaladeepika-ch1-s19', hi: '1.19 राहु', en: 'Rahu' },
      { id: 'phaladeepika-ch1-s20', hi: '1.20 केतु', en: 'Ketu' },
      { id: 'phaladeepika-ch1-s21', hi: '1.21 शुभ/अशुभ', en: 'Benefic/Malefic' },
      { id: 'phaladeepika-ch1-s22', hi: '1.22 षड्बल', en: 'Shadbala' },
      { id: 'phaladeepika-ch1-s23', hi: '1.23 दिग्बल', en: 'Digbala' },
      { id: 'phaladeepika-ch1-s24', hi: '1.24 कालबल', en: 'Kalabala' },
      { id: 'phaladeepika-ch1-s25', hi: '1.25 स्थानबल', en: 'Sthanabala' },
      { id: 'phaladeepika-ch1-s26', hi: '1.26 दृक्बल', en: 'Drikbala' },
      { id: 'phaladeepika-ch1-s27', hi: '1.27 चेष्टाबल', en: 'Cheshtabala' },
      { id: 'phaladeepika-ch1-s28', hi: '1.28 नैसर्गिक बल', en: 'Natural Strength' },
      { id: 'phaladeepika-ch1-s29', hi: '1.29 ग्रह युद्ध', en: 'Planet War' },
      { id: 'phaladeepika-ch1-s30', hi: '1.30 उपसंहार', en: 'Conclusion' },
    ],
  },
  {
    id: 'ch2',
    hi: 'अध्याय 2 · भावाध्याय',
    en: 'Chapter 2 · Houses (Bhavas)',
    color: 'from-violet-500/20 via-purple-500/10 to-fuchsia-500/5',
    ring: { d: 'ring-violet-400/20', l: 'ring-violet-200' },
    badge: { d: 'bg-violet-400/15 text-violet-100', l: 'bg-violet-100 text-violet-900' },
    accent: { d: 'text-violet-200', l: 'text-violet-900' },
    tabs: [
      { id: 'phaladeepika-ch2-s1', hi: '2.1 प्रथम भाव', en: '1st House' },
      { id: 'phaladeepika-ch2-s2', hi: '2.2 द्वितीय भाव', en: '2nd House' },
      { id: 'phaladeepika-ch2-s3', hi: '2.3 तृतीय भाव', en: '3rd House' },
      { id: 'phaladeepika-ch2-s4', hi: '2.4 चतुर्थ भाव', en: '4th House' },
      { id: 'phaladeepika-ch2-s5', hi: '2.5 पंचम भाव', en: '5th House' },
      { id: 'phaladeepika-ch2-s6', hi: '2.6 षष्ठ भाव', en: '6th House' },
      { id: 'phaladeepika-ch2-s7', hi: '2.7 सप्तम भाव', en: '7th House' },
      { id: 'phaladeepika-ch2-s8', hi: '2.8 अष्टम भाव', en: '8th House' },
      { id: 'phaladeepika-ch2-s9', hi: '2.9 नवम भाव', en: '9th House' },
      { id: 'phaladeepika-ch2-s10', hi: '2.10 दशम भाव', en: '10th House' },
      { id: 'phaladeepika-ch2-s11', hi: '2.11 एकादश भाव', en: '11th House' },
      { id: 'phaladeepika-ch2-s12', hi: '2.12 द्वादश भाव', en: '12th House' },
    ],
  },
  {
    id: 'ch3',
    hi: 'अध्याय 3 · लग्नाध्याय',
    en: 'Chapter 3 · Ascendant (Lagnas)',
    color: 'from-teal-500/20 via-emerald-500/10 to-green-500/5',
    ring: { d: 'ring-teal-400/20', l: 'ring-teal-200' },
    badge: { d: 'bg-teal-400/15 text-teal-100', l: 'bg-teal-100 text-teal-900' },
    accent: { d: 'text-teal-200', l: 'text-teal-900' },
    tabs: [
      { id: 'phaladeepika-ch3-s1', hi: '3.1 मेष लग्न', en: 'Aries Lagna' },
      { id: 'phaladeepika-ch3-s2', hi: '3.2 वृषभ लग्न', en: 'Taurus Lagna' },
      { id: 'phaladeepika-ch3-s3', hi: '3.3 मिथुन लग्न', en: 'Gemini Lagna' },
      { id: 'phaladeepika-ch3-s4', hi: '3.4 कर्क लग्न', en: 'Cancer Lagna' },
      { id: 'phaladeepika-ch3-s5', hi: '3.5 सिंह लग्न', en: 'Leo Lagna' },
      { id: 'phaladeepika-ch3-s6', hi: '3.6 कन्या लग्न', en: 'Virgo Lagna' },
      { id: 'phaladeepika-ch3-s7', hi: '3.7 तुला लग्न', en: 'Libra Lagna' },
      { id: 'phaladeepika-ch3-s8', hi: '3.8 वृश्चिक लग्न', en: 'Scorpio Lagna' },
      { id: 'phaladeepika-ch3-s9', hi: '3.9 धनु लग्न', en: 'Sagittarius Lagna' },
      { id: 'phaladeepika-ch3-s10', hi: '3.10 मकर लग्न', en: 'Capricorn Lagna' },
      { id: 'phaladeepika-ch3-s11', hi: '3.11 कुम्भ लग्न', en: 'Aquarius Lagna' },
      { id: 'phaladeepika-ch3-s12', hi: '3.12 मीन लग्न', en: 'Pisces Lagna' },
    ],
  },
  {
    id: 'ch4',
    hi: 'अध्याय 4 · भावफल',
    en: 'Chapter 4 · Results of Houses',
    color: 'from-sky-500/20 via-cyan-500/10 to-blue-500/5',
    ring: { d: 'ring-sky-400/20', l: 'ring-sky-200' },
    badge: { d: 'bg-sky-400/15 text-sky-100', l: 'bg-sky-100 text-sky-900' },
    accent: { d: 'text-sky-200', l: 'text-sky-900' },
    tabs: [
      { id: 'phaladeepika-ch4-s1', hi: '4.1 प्रथम भाव फल', en: '1st House Results' },
      { id: 'phaladeepika-ch4-s2', hi: '4.2 द्वितीय भाव फल', en: '2nd House Results' },
      { id: 'phaladeepika-ch4-s3', hi: '4.3 तृतीय भाव फल', en: '3rd House Results' },
      { id: 'phaladeepika-ch4-s4', hi: '4.4 चतुर्थ भाव फल', en: '4th House Results' },
      { id: 'phaladeepika-ch4-s5', hi: '4.5 पंचम भाव फल', en: '5th House Results' },
      { id: 'phaladeepika-ch4-s6', hi: '4.6 षष्ठ भाव फल', en: '6th House Results' },
      { id: 'phaladeepika-ch4-s7', hi: '4.7 सप्तम भाव फल', en: '7th House Results' },
      { id: 'phaladeepika-ch4-s8', hi: '4.8 अष्टम भाव फल', en: '8th House Results' },
      { id: 'phaladeepika-ch4-s9', hi: '4.9 नवम भाव फल', en: '9th House Results' },
      { id: 'phaladeepika-ch4-s10', hi: '4.10 दशम भाव फल', en: '10th House Results' },
      { id: 'phaladeepika-ch4-s11', hi: '4.11 एकादश भाव फल', en: '11th House Results' },
      { id: 'phaladeepika-ch4-s12', hi: '4.12 द्वादश भाव फल', en: '12th House Results' },
    ],
  },
  {
    id: 'ch5',
    hi: 'अध्याय 5 · राजयोग',
    en: 'Chapter 5 · Royal Combinations (Raja Yogas)',
    color: 'from-amber-500/20 via-yellow-500/10 to-lime-500/5',
    ring: { d: 'ring-amber-400/20', l: 'ring-amber-200' },
    badge: { d: 'bg-amber-400/15 text-amber-100', l: 'bg-amber-100 text-amber-900' },
    accent: { d: 'text-amber-200', l: 'text-amber-900' },
    tabs: [
      { id: 'phaladeepika-ch5-s1', hi: '5.1 राजयोग परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch5-s2', hi: '5.2 पंचमहापुरुष', en: 'Pancha Mahapurusha' },
      { id: 'phaladeepika-ch5-s3', hi: '5.3 केन्द्र-त्रिकोण', en: 'Kendra-Trikona' },
      { id: 'phaladeepika-ch5-s4', hi: '5.4 धन योग', en: 'Dhana Yoga' },
      { id: 'phaladeepika-ch5-s5', hi: '5.5 गजकेसरी', en: 'Gajakesari' },
      { id: 'phaladeepika-ch5-s6', hi: '5.6 बुधादित्य', en: 'Budhaditya' },
      { id: 'phaladeepika-ch5-s7', hi: '5.7 अमला', en: 'Amala' },
      { id: 'phaladeepika-ch5-s8', hi: '5.8 धर्म-कर्म', en: 'Dharma-Karma' },
      { id: 'phaladeepika-ch5-s9', hi: '5.9 विपरीत', en: 'Viparit' },
      { id: 'phaladeepika-ch5-s10', hi: '5.10 नीचभंग', en: 'Neechabhanga' },
      { id: 'phaladeepika-ch5-s11', hi: '5.11 चामर आदि', en: 'Chamar etc' },
      { id: 'phaladeepika-ch5-s12', hi: '5.12 योगभंग', en: 'Yoga Bhanga' },
    ],
  },
  {
    id: 'ch6',
    hi: 'अध्याय 6 · अरिष्टाध्याय',
    en: 'Chapter 6 · Arishta Yogas (Misfortune)',
    color: 'from-red-500/20 via-rose-500/10 to-pink-500/5',
    ring: { d: 'ring-red-400/20', l: 'ring-red-200' },
    badge: { d: 'bg-red-400/15 text-red-100', l: 'bg-red-100 text-red-900' },
    accent: { d: 'text-red-200', l: 'text-red-900' },
    tabs: [
      { id: 'phaladeepika-ch6-s1', hi: '6.1 अरिष्ट परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch6-s2', hi: '6.2 बालारिष्ट', en: 'Balarishta' },
      { id: 'phaladeepika-ch6-s3', hi: '6.3 चन्द्र अरिष्ट', en: 'Moon Arishta' },
      { id: 'phaladeepika-ch6-s4', hi: '6.4 लग्न अरिष्ट', en: 'Lagna Arishta' },
      { id: 'phaladeepika-ch6-s5', hi: '6.5 सूर्य अरिष्ट', en: 'Sun Arishta' },
      { id: 'phaladeepika-ch6-s6', hi: '6.6 मंगल अरिष्ट', en: 'Mars Arishta' },
      { id: 'phaladeepika-ch6-s7', hi: '6.7 बुध अरिष्ट', en: 'Mercury Arishta' },
      { id: 'phaladeepika-ch6-s8', hi: '6.8 गुरु अरिष्ट', en: 'Jupiter Arishta' },
      { id: 'phaladeepika-ch6-s9', hi: '6.9 शुक्र अरिष्ट', en: 'Venus Arishta' },
      { id: 'phaladeepika-ch6-s10', hi: '6.10 शनि अरिष्ट', en: 'Saturn Arishta' },
      { id: 'phaladeepika-ch6-s11', hi: '6.11 राहु-केतु अरिष्ट', en: 'Rahu-Ketu Arishta' },
      { id: 'phaladeepika-ch6-s12', hi: '6.12 अरिष्ट भंग', en: 'Arishta Bhanga' },
    ],
  },
  {
    id: 'ch7',
    hi: 'अध्याय 7 · आयुर्दय',
    en: 'Chapter 7 · Determination of Longevity',
    color: 'from-indigo-500/20 via-blue-500/10 to-violet-500/5',
    ring: { d: 'ring-indigo-400/20', l: 'ring-indigo-200' },
    badge: { d: 'bg-indigo-400/15 text-indigo-100', l: 'bg-indigo-100 text-indigo-900' },
    accent: { d: 'text-indigo-200', l: 'text-indigo-900' },
    tabs: [
      { id: 'phaladeepika-ch7-s1', hi: '7.1 आयुर्दय परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch7-s2', hi: '7.2 पिण्डायु विधि', en: 'Pindayu Method' },
      { id: 'phaladeepika-ch7-s3', hi: '7.3 अंशायु विधि', en: 'Amshayu Method' },
      { id: 'phaladeepika-ch7-s4', hi: '7.4 नैसर्गिक आयु', en: 'Natural Longevity' },
      { id: 'phaladeepika-ch7-s5', hi: '7.5 अष्टकवर्ग आयु', en: 'Ashtakavarga Method' },
      { id: 'phaladeepika-ch7-s6', hi: '7.6 लग्न आयु', en: 'Lagna Longevity' },
      { id: 'phaladeepika-ch7-s7', hi: '7.7 चन्द्र आयु', en: 'Moon Longevity' },
      { id: 'phaladeepika-ch7-s8', hi: '7.8 ग्रह बल आयु', en: 'Planetary Strength' },
      { id: 'phaladeepika-ch7-s9', hi: '7.9 दशा आधारित आयु', en: 'Dasha-based' },
      { id: 'phaladeepika-ch7-s10', hi: '7.10 मारक ग्रह', en: 'Maraka Planets' },
      { id: 'phaladeepika-ch7-s11', hi: '7.11 मारक दशा', en: 'Maraka Dasha' },
      { id: 'phaladeepika-ch7-s12', hi: '7.12 आयु वृद्धि उपाय', en: 'Longevity Remedies' },
    ],
  },
  {
    id: 'ch8',
    hi: 'अध्याय 8 · दशाध्याय',
    en: 'Chapter 8 · Planetary Periods (Dashas)',
    color: 'from-rose-500/20 via-pink-500/10 to-fuchsia-500/5',
    ring: { d: 'ring-rose-400/20', l: 'ring-rose-200' },
    badge: { d: 'bg-rose-400/15 text-rose-100', l: 'bg-rose-100 text-rose-900' },
    accent: { d: 'text-rose-200', l: 'text-rose-900' },
    tabs: [
      { id: 'phaladeepika-ch8-s2', hi: '8.2 विंशोत्तरी दशा', en: 'Vimshottari Dasha' },
      { id: 'phaladeepika-ch8-s3', hi: '8.3 सूर्य दशा फल', en: 'Sun Dasha' },
      { id: 'phaladeepika-ch8-s4', hi: '8.4 चन्द्र दशा फल', en: 'Moon Dasha' },
      { id: 'phaladeepika-ch8-s5', hi: '8.5 मंगल दशा फल', en: 'Mars Dasha' },
      { id: 'phaladeepika-ch8-s6', hi: '8.6 राहु दशा फल', en: 'Rahu Dasha' },
      { id: 'phaladeepika-ch8-s7', hi: '8.7 गुरु दशा फल', en: 'Jupiter Dasha' },
      { id: 'phaladeepika-ch8-s8', hi: '8.8 शनि दशा फल', en: 'Saturn Dasha' },
      { id: 'phaladeepika-ch8-s9', hi: '8.9 बुध दशा फल', en: 'Mercury Dasha' },
      { id: 'phaladeepika-ch8-s10', hi: '8.10 केतु दशा फल', en: 'Ketu Dasha' },
      { id: 'phaladeepika-ch8-s11', hi: '8.11 शुक्र दशा फल', en: 'Venus Dasha' },
      { id: 'phaladeepika-ch8-s12', hi: '8.12 दशा विशेष नियम', en: 'Special Rules' },
    ],
  },
  {
    id: 'ch9',
    hi: 'अध्याय 9 · अन्तर्दशा',
    en: 'Chapter 9 · Antardasha (Sub-periods)',
    color: 'from-teal-500/20 via-cyan-500/10 to-sky-500/5',
    ring: { d: 'ring-teal-400/20', l: 'ring-teal-200' },
    badge: { d: 'bg-teal-400/15 text-teal-100', l: 'bg-teal-100 text-teal-900' },
    accent: { d: 'text-teal-200', l: 'text-teal-900' },
    tabs: [
      { id: 'phaladeepika-ch9-s1', hi: '9.1 अन्तर्दशा परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch9-s2', hi: '9.2 अन्तर्दशा काल विभाग', en: 'Time Division' },
      { id: 'phaladeepika-ch9-s3', hi: '9.3 महादशा अन्तर क्रम', en: 'Order in MD' },
      { id: 'phaladeepika-ch9-s4', hi: '9.4 मित्र अन्तर्दशा फल', en: 'Friendly Antar' },
      { id: 'phaladeepika-ch9-s5', hi: '9.5 शत्रु अन्तर्दशा फल', en: 'Enemy Antar' },
      { id: 'phaladeepika-ch9-s6', hi: '9.6 शुभ-शुभ योग', en: 'Benefic + Benefic' },
      { id: 'phaladeepika-ch9-s7', hi: '9.7 शुभ-अशुभ मिश्रण', en: 'Mixed Pairs' },
      { id: 'phaladeepika-ch9-s8', hi: '9.8 मारक अन्तर्दशा', en: 'Maraka Antar' },
      { id: 'phaladeepika-ch9-s9', hi: '9.9 राहु-केतु अन्तर', en: 'Rahu-Ketu Antar' },
      { id: 'phaladeepika-ch9-s10', hi: '9.10 प्रत्यन्तर्दशा', en: 'Pratyantardasha' },
      { id: 'phaladeepika-ch9-s11', hi: '9.11 गोचर और अन्तर', en: 'Transit + Antar' },
      { id: 'phaladeepika-ch9-s12', hi: '9.12 सूक्ष्म निष्कर्ष', en: 'Fine Conclusion' },
    ],
  },
  {
    id: 'ch10',
    hi: 'अध्याय 10 · अष्टकवर्ग फल',
    en: 'Chapter 10 · Ashtakavarga Phala',
    color: 'from-violet-500/20 via-purple-500/10 to-fuchsia-500/5',
    ring: { d: 'ring-violet-400/20', l: 'ring-violet-200' },
    badge: { d: 'bg-violet-400/15 text-violet-100', l: 'bg-violet-100 text-violet-900' },
    accent: { d: 'text-violet-200', l: 'text-violet-900' },
    tabs: [
      { id: 'phaladeepika-ch10-s1', hi: '10.1 अष्टकवर्ग फल परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch10-s2', hi: '10.2 बिन्दु का अर्थ', en: 'Meaning of Bindu' },
      { id: 'phaladeepika-ch10-s3', hi: '10.3 पृथक अष्टकवर्ग', en: 'Individual AV' },
      { id: 'phaladeepika-ch10-s4', hi: '10.4 सर्वाष्टकवर्ग (SAV)', en: 'Sarvashtakavarga' },
      { id: 'phaladeepika-ch10-s5', hi: '10.5 समुदाय बल', en: 'Samudaya Strength' },
      { id: 'phaladeepika-ch10-s6', hi: '10.6 गोचर और बिन्दु', en: 'Transit + Bindus' },
      { id: 'phaladeepika-ch10-s7', hi: '10.7 अधिक बिन्दु राशि', en: 'High-Bindu Signs' },
      { id: 'phaladeepika-ch10-s8', hi: '10.8 कम बिन्दु राशि', en: 'Low-Bindu Signs' },
      { id: 'phaladeepika-ch10-s9', hi: '10.9 भाव और बिन्दु', en: 'Houses + Bindus' },
      { id: 'phaladeepika-ch10-s10', hi: '10.10 द्विग्रह गोचर', en: 'Double Transit' },
      { id: 'phaladeepika-ch10-s11', hi: '10.11 अष्टकवर्ग उपाय', en: 'AV Remedies' },
      { id: 'phaladeepika-ch10-s12', hi: '10.12 दशा-गोचर संयोजन', en: 'Dasha + Gochar' },
    ],
  },
  {
    id: 'ch11',
    hi: 'अध्याय 11 · स्त्री जातक फल',
    en: 'Chapter 11 · Stri Jataka',
    color: 'from-pink-500/20 via-rose-500/10 to-orange-500/5',
    ring: { d: 'ring-pink-400/20', l: 'ring-pink-200' },
    badge: { d: 'bg-pink-400/15 text-pink-100', l: 'bg-pink-100 text-pink-900' },
    accent: { d: 'text-pink-200', l: 'text-pink-900' },
    tabs: [
      { id: 'phaladeepika-ch11-s1', hi: '11.1 स्त्री जातक परिचय', en: 'Introduction' },
      { id: 'phaladeepika-ch11-s2', hi: '11.2 लग्न और चंद्र', en: 'Lagna & Moon' },
      { id: 'phaladeepika-ch11-s3', hi: '11.3 अष्टम भाव', en: 'Eighth House' },
      { id: 'phaladeepika-ch11-s4', hi: '11.4 सप्तम और शुक्र', en: 'Seventh & Venus' },
      { id: 'phaladeepika-ch11-s5', hi: '11.5 पंचम संतति', en: 'Fifth · Progeny' },
      { id: 'phaladeepika-ch11-s6', hi: '11.6 शुक्र और गुरु', en: 'Venus & Jupiter' },
      { id: 'phaladeepika-ch11-s7', hi: '11.7 मंगल संयोग', en: 'Mars Combinations' },
      { id: 'phaladeepika-ch11-s8', hi: '11.8 दुस्थान सामंजस्य', en: 'Dusthana Balance' },
      { id: 'phaladeepika-ch11-s9', hi: '11.9 विवाह का समय', en: 'Marriage Timing' },
      { id: 'phaladeepika-ch11-s10', hi: '11.10 चंद्र और स्वास्थ्य', en: 'Moon & Health' },
      { id: 'phaladeepika-ch11-s11', hi: '11.11 नैतिक सीमा', en: 'Ethics' },
      { id: 'phaladeepika-ch11-s12', hi: '11.12 अध्याय सार', en: 'Summary' },
    ],
  },
];

export const PHALADEEPIKA_MARGA_TABS = PHALADEEPIKA_CHAPTERS.flatMap((ch) => ch.tabs);

export const PHALADEEPIKA_TOPIC_COUNT = PHALADEEPIKA_MARGA_TABS.length;

export const PHALADEEPIKA_CHAPTER_COUNT = PHALADEEPIKA_CHAPTERS.length;
